// CONF
import { CreateConf } from './conf/Create.conf';

// REDUX
import { reducer, actions, detailSelector, listSelector } from './slice';

// SELECTOR
import { tag, querySelector } from './slice';

// SAGA
import { saga } from './saga';

// API
import { API } from './api';
import { ListConf } from './conf/List.conf';
import { DetailConf } from './conf/Detail.conf';
import { ActionConf } from './conf/Action.conf';
import { SearchConf } from './conf/Search.conf';
import { FilterConf } from './conf/Filter.conf';
import { UpdateProductConf } from './conf/Update.conf';

export { reducer, saga, tag };

const itemsInteriors = {
  code: 'INT',
  tag,
  query: {
    all: {
      selector: querySelector,
      action: actions.fetchAllAction,
      settings: API.list,
      populate: '*',
    },
    detail: {
      action: actions.fetchDetailAction,
      settings: API.listItemsNOLogbook,
      populate: '*',
    },
    edit: {
      settings: API.update,
    },
    create: {
      settings: API.create,
    },
    delete: {
      settings: API.delete,
      move: API.deleteMove,
    },
    action: {
      settings: API.updateAllRows,
    },
  },
  search: {
    conf: SearchConf,
    actions: {
      search: actions.searchChange,
    },
  },
  filter: {
    conf: FilterConf,
    actions: {
      filter: actions.filterChange,
    },
  },
  list: {
    conf: ListConf,
    actions: {
      pagination: actions.paginationChange,
      sort: actions.sortChange,
    },
    selector: {
      data: listSelector,
    },
  },

  detail: {
    conf: DetailConf,
    selector: {
      data: detailSelector,
    },
  },
  edit: {
    conf: UpdateProductConf,
  },
  create: {
    conf: CreateConf,
  },

  action: {
    conf: ActionConf,
  },
};

export default itemsInteriors;
